import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import PostJob from "./post_job/PostJob";
import { auth, db, ref } from "../utilities/firebaseConfig";
import { get, onValue } from "firebase/database";
import ClickOutsideWrapper from "./ClickOutSideWrapper";
import MyAccount from "./my_account/MyAccount";
import { getAuth, signOut } from "firebase/auth";
import Pricing from "./pricing/Pricing";
import TechnicianAccount from "./my_account/TechnicianAccount";
import NotificationBell from "./NotificationBell";

function TechnicianDashboardLayout({ children }) {
  const [isModalOpen, setModalOpen] = useState(false);
  const [isAccountOpen, setIsAccountOpen] = useState(false);
  const [isPricing, setIsPricing] = useState(false);
  const [showNotfModal, setShowNotfModal] = useState(false);
  const [showProfModal, setShowProfModal] = useState(false);
  const [activeJobs, setActiveJobs] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [online, setOnline] = useState(false);
  const [technician, setTechnician] = useState(null);
  const [tasks, setTasks] = useState([]);
  const [pendingCount, setPendingCount] = useState(0);
  const [pendingJobs, setPendingJobs] = useState([]);
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const user = auth.currentUser;
  useEffect(() => {
    const user = auth.currentUser;
    if (!user) {
      navigate("/");
      return;
    }

    const technicianId = auth.currentUser ? auth.currentUser.uid : null;
    if (!technicianId) return;

    // Fetch technician details
    const technicianRef = ref(db, `technicians/${user.uid}`);
    onValue(technicianRef, (snapshot) => {
      if (snapshot.exists()) {
        const techData = snapshot.val();
        setTechnician(techData);
        setOnline(techData.online);
      }
    });

    // Fetch tasks assigned to the technician
    const tasksRef = ref(db, "jobs");
    onValue(tasksRef, (snapshot) => {
      if (snapshot.exists()) {
        let tasksData = Object.entries(snapshot.val()).map(([id, task]) => ({
          id,
          ...task,
        }));
        let pendingJobs = tasksData.filter(
          (task) =>
            task.technicianId === technicianId && task.status === "pending"
        );
        let activeJobs = tasksData.filter(
          (task) =>
            task.technicianId === technicianId && task.status === "accepted"
        );

        setPendingJobs(pendingJobs);
        setActiveJobs(activeJobs);
        setPendingCount(pendingJobs.length);
        setTasks(
          tasksData.filter(
            (task) =>
              task.technicianId === user.uid &&
              task.status !== "completed" &&
              task.status !== "cancelled"
          )
        );
      }
    });
  }, [navigate]);

  const handleSignOut = async () => {
    const auth = getAuth();
    try {
      await signOut(auth);
      console.log("User signed out");
      navigate("/login"); // redirect to login page
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };
  return (
    <>
      <TechnicianAccount
        isOpen={isAccountOpen}
        onClose={() => setIsAccountOpen(false)}
      />
      <div className='dashboardlayout_cnt'>
        <div className='dashboardlayout_sidebar'>
          <Link to='/client/dashboard' className='dashlogo'>
            Profixexpress
          </Link>
          <div className='thespacee'></div>
          <div className='thespacee'></div>
          <div className='thespace'></div>
          <div className='dashtaskcenter'>
            <p className='dashtaskcenterp'>My tasks</p>
          </div>
          <div className='thespac'></div>
          <div className='dashdivider'></div>
          <div className='thespac'></div>
          {tasks.length > 0 ? (
            tasks.map((job) => (
              <>
                {" "}
                <div
                  className='dashtas'
                  key={job.id}
                  onClick={() => navigate(`/technician/task_details/${job.id}`)}
                >
                  <p className='actjobtitle'>{job.jobtitle}</p>
                  <p className='actjobprog'>{job.status}</p>
                </div>
              </>
            ))
          ) : (
            <p>You have no task yet.</p>
          )}

          <div className='thespacee'></div>
          <div className='thespacee'></div>
          <div className='dashtaskcenter'>
            <p className='dashtaskcenterp'>Quick Links</p>
          </div>
          <div className='thespac'></div>
          <div className='dashdivider'></div>
          <div className='thespac'></div>
          <div className='navbartheview'>
            <Link className='thslas' to='/technician/job-history'>
              Job History
            </Link>
            <div className='thespace'></div>
            <Link className='thslas' to='/technician/wallet'>
              My Wallet
            </Link>
            <div className='thespace'></div>
            <Link className='thslas' to='/client/support'>
              Support
            </Link>
          </div>
        </div>
        <div className='dashboardlayout_bodycnt'>
          <div className='dashboardlayout_bodytop'>
            <div className='dlbdyleft'></div>
            <div className='dlbdyright'>
              <div className='notificationcent'>
                <NotificationBell />
              </div>

              <div className='navproficnt'>
                <button
                  className='dldpro'
                  onClick={() => setShowProfModal(true)}
                >
                  {`${technician?.name?.[0] || ""}${
                    technician?.lastName?.[0] || ""
                  }`.toUpperCase()}
                </button>
                {showProfModal && (
                  <ClickOutsideWrapper
                    onClickOutside={() => setShowProfModal(false)}
                  >
                    <div className='navpfrcasn'>
                      <p className='navpname'>
                        {`${technician?.name?.[0] || ""}${
                          technician?.lastName?.[0] || ""
                        }`.toUpperCase()}
                      </p>
                      <div className='thegap'></div>
                      <h1 className='navpnamepar'>
                        {technician?.name} {technician?.lastName}
                      </h1>
                      <p className='navpnameparemail'>{technician?.email}</p>
                      <div className='thegap'></div>
                      <button
                        className='navpracnt'
                        onClick={() => {
                          setIsAccountOpen(true);
                          setShowProfModal(false);
                        }}
                      >
                        My Account
                      </button>
                      <div className='thespac'></div>
                      <div className='dividar'></div>
                      <div className='thespac'></div>
                      <div className='theproslink'>
                        <Link>Help & FAQ</Link>
                        <div className='thegap'></div>
                        <Link>Report a problem</Link>
                      </div>
                      <div className='thespac'></div>
                      <div className='dividar'></div>
                      <div className='thespac'></div>
                      <div className='theproslink'>
                        <button className='tepsabtn' onClick={handleSignOut}>
                          Log out
                        </button>
                      </div>
                    </div>
                  </ClickOutsideWrapper>
                )}
              </div>
            </div>
          </div>
          <div className='dashboardlayout_bodybottom'>{children}</div>
        </div>
      </div>
    </>
  );
}

export default TechnicianDashboardLayout;
